import { cn } from '@/lib/utils';

interface ChartEmptyProps {
  /** Already-resolved text — the primitives never see a translation key. */
  label: string;
  /**
   * The panel's own layout classes. Every chart takes this branch in place of
   * its plot, so the placeholder has to carry the grid span and margins the
   * plot would have — a panel that loses them collapses out of the page's
   * composition in exactly the state where the page most needs to look
   * deliberate.
   */
  className?: string;
}

// What every chart panel renders when it has no series at all. Shared so a
// window with no issuing looks the same in all four panels.
export function ChartEmpty({ label, className }: ChartEmptyProps) {
  return (
    <p
      className={cn(
        'rounded-md border border-dashed border-line-2 bg-paper-2 px-4 py-6 text-center text-[13px] text-muted',
        className,
      )}
    >
      {label}
    </p>
  );
}
